// modules
import { handleActions } from 'redux-actions'

// actions
import { setCompanyReferences } from 'src/store/modules/company/refs/actionCreators'

const refsPattern = {
  phones: [],
  emails: [],
  addresses: [],
  programDischargeReasons: [],
  relationship: [],
  medicalSpecialties: [],
  genders: [],
  patientGroups: [],
  languages: [],
  activityTypes: [],
  auditLogTimer: [],
  education: [],
  checkIn: [],
  measurement: [],
  chat: [],
  broadcastCategoryList: [],
  eventTypes: [],
  enrollProgramType: [],
  medicationSkipReason: [],
  carePlanResponsible: [],
  backfillMedication: [],
  backfillCarePlan: [],
  patientProvider: [],
  patientInsurance: [],
  medicalDevices: [],
  prognosis: [],
  telemedicine: [],
  riskLevel: [],
  emergencyPreparednessRiskLevel: [],
  modeOfTransportation: [],
  externalDocumentType: [],
  patientHoldReason: [],
  alertQuickCloseReasons: [],
  medicalEquipmentStatuses: [],
  medicalEquipmentCategories: [],
  medicalDeviceTrainingStatus: [],
  medicalDeviceShipmentStatus: [],
  telemedicineCallType: [],
  taskStatus: [],
  taskType: [],
  taskAction: [],
  urgentCareOutcome: [],
  telemedicineCallOutcome: [],
  refuseServiceReasons: [],
  referralReasons: [],
  referralOutreachStatuses: [],
  appointmentStatuses: []
}

const initialState = {
  references: refsPattern
}

export default handleActions(
  {
    [`${setCompanyReferences}`](state: any, { payload: references }: any) {
      return references
    }
  },
  initialState
)
